import {
  startOfDay,
  startOfMinute,
  startOfHour,
  setHours,
  addDays,
  addYears,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { TZDate } from "react-day-picker";

/**
 * Dates used inside the DayPicker component need to be timezone-aware TZDate
 * objects, as the day selected is referenced to a particular timezone.
 */
export function toTZDate(date: Date, timeZone: string): TZDate {
  return TZDate.tz(timeZone, date.getTime());
}

/**
 * Dates returned from the DayPicker will be TZDate, so we unwrap them back
 * to a standard Date.
 *
 * @param date - this is a TZDate
 */
export function fromTZDate(date: Date): Date {
  return new Date(date.getTime());
}

export function startOfDayInTimeZone(value: Date, timeZone: string): Date {
  const zoned = utcToZonedTime(value, timeZone);
  const zonedStart = startOfDay(zoned);
  return zonedTimeToUtc(zonedStart, timeZone);
}

export function startOfMinuteInTimeZone(value: Date, timeZone: string): Date {
  const zoned = utcToZonedTime(value, timeZone);
  const zonedStart = startOfMinute(zoned);
  return zonedTimeToUtc(zonedStart, timeZone);
}

export function startOfHourInTimeZone(value: Date, timeZone: string): Date {
  const zoned = utcToZonedTime(value, timeZone);
  const zonedStart = startOfHour(zoned);
  return zonedTimeToUtc(zonedStart, timeZone);
}

export function middayInTimeZone(value: Date, timeZone: string): Date {
  const zoned = utcToZonedTime(value, timeZone);
  const zonedStart = setHours(zoned, 12);
  return zonedTimeToUtc(zonedStart, timeZone);
}

export function addDaysInTimezone(
  date: Date,
  days: number,
  timeZone: string,
): Date {
  const zoned = utcToZonedTime(date, timeZone);
  const addMonth = addDays(zoned, days);
  return zonedTimeToUtc(addMonth, timeZone);
}

export function addYearsInTimezone(
  date: Date,
  years: number,
  timeZone: string,
): Date {
  const zoned = utcToZonedTime(date, timeZone);
  const addMonth = addYears(zoned, years);
  return zonedTimeToUtc(addMonth, timeZone);
}
